module.exports = __webpack_public_path__ + "img/Loading_r_21.eb0ff960.png";